<template>
  <div class="container">
    <div class="nav-img">
      <img v-if="url.indexOf('shian360.com') != -1" src="@/assets/stlogo.png" />
      <img v-else src="@/assets/cqqlogo.png" />
      <!-- <img src="@/assets/cqqlogo.png" /> -->
      <!-- <div class="logo-title">菜圈圈科技</div> -->
      <div class="nav-btn">
        <el-button type="primary" @click="login()">已有账号，登录</el-button>
        <el-button type="primary" @click="openHonme()">回到首页</el-button>
      </div>
    </div>
    <div class="form-con">
      <div class="release-title">账号创建</div>
      <el-row>
        <el-col :span="16">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="登录密码" prop="password">
              <el-input v-model="ruleForm.password"></el-input>
            </el-form-item>
            <el-form-item label="供应商名称" prop="nickname">
              <el-input v-model="ruleForm.nickname"></el-input>
            </el-form-item>
            <el-form-item label="区域" prop="region">
              <el-select v-model="ruleForm.region" placeholder="请选择省份" @change="changesetre">
                <el-option v-for="item in regionData1" :label="item.name" :value="item.name" :key="item.id"></el-option>
              </el-select>
              <el-select v-model="ruleForm.province" placeholder="请选择市" @change="changesetpro">
                <el-option v-for="item in regionData2" :label="item.name" :value="item.name" :key="item.id"></el-option>
              </el-select>
              <el-select v-model="ruleForm.area" placeholder="请选择区" @change="changesetarea">
                <el-option v-for="item in regionData3" :label="item.name" :value="item.name" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人" prop="liaison">
              <el-input v-model="ruleForm.liaison"></el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="address">
              <el-input v-model="ruleForm.address"></el-input>
            </el-form-item>
            <el-form-item label="供应商简介" prop="memo">
              <el-input type="textarea" v-model="ruleForm.memo"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { proModuleApi } from '@/api/home'
export default {
  name: 'register',
  data() {
    return {
      regionData1: [],
      regionData2: [],
      regionData3: [],
      ruleForm: {
        phone: '',
        nickname: '',
        password: '',
        liaison: '',
        address: '',
        memo: '',
        region: [],
        province: '',
        city: '',
        region_code: ''
      },
      rules: {
        phone: [
          { required: true, message: '请输入11位数的正确手机号码', trigger: 'blur' },
          { message: '长度为11位数的正确手机号码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入不少于3位的密码', trigger: 'blur' },
          { min: 3, max: 15, message: '长度在 3 到 15个字符', trigger: 'blur' }
        ],
        nickname: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        liaison: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
        address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
        region: [
          {
            required: true,
            message: '身份不能为空',
            trigger: 'blur'
          }
        ],
        province: [
          {
            required: true,
            message: '市不能为空',
            trigger: 'blur'
          }
        ],
        city: [
          {
            required: true,
            message: '区不能为空',
            trigger: 'blur'
          }
        ],
        memo: [{ required: true, message: '请填写供应商简介', trigger: 'blur' }]
      },
      url: ''
    }
  },
  created() {
    this.url = window.location.hostname
    this.getRegionInfo()
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {}
          params.nickname = this.ruleForm.nickname
          params.phone = this.ruleForm.phone
          params.password = this.ruleForm.password
          params.liaison = this.ruleForm.liaison
          params.region = []
          params.region[0] = this.ruleForm.region
          params.region[1] = this.ruleForm.province
          params.region[2] = this.ruleForm.area
          params.region_code = this.region_code
          params.address = this.ruleForm.address
          params.memo = this.ruleForm.memo
          console.log(params)
          proModuleApi
            .registerInfo(params)
            .then(res => {
              this.$router.push({ path: '/index' })
              console.log(res.msg)
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getRegionInfo() {
      proModuleApi
        .regionInfo({
          type: 'tree',
          level: 3
        })
        .then(res => {
          this.regionData1 = res
        })
        .catch()
    },
    changesetre(val) {
      if (val) {
        let data = []
        data = this.regionData1.filter(item => item.name == val)
        this.regionData2 = data[0].children
      }
    },
    changesetpro(val) {
      if (val) {
        let data = []
        data = this.regionData2.filter(item => item.name == val)
        this.regionData3 = data[0].children
      }
    },
    changesetarea(val) {
      if (val) {
        let obj = []
        obj = this.regionData3.filter(item => item.name == val)
        this.region_code = obj[0].id
      }
    },
    openHonme() {
      this.$router.push({ path: '/index' })
    },
    login() {
      this.$router.push({ path: '/login' })
    }
  }
}
</script>
<style scoped>
.nav-img {
  width: 1200px;
  margin: 0 auto;
}
.nav-img img {
  width: 400px;
  height: 300px;
  margin-top: -80px;
}
.logo-title {
  /* margin-top: -150px; */
  color: #fc6720;
  float: right;
  position: absolute;
  left: 450px;
  top: 60px;
  font-size: 22px;
}
.form-con {
  width: 1200px;
  margin: 0 auto;
  margin-top: -80px;
}
.release-title {
  background-color: #107a53;
  height: 50px;
  line-height: 50px;
  color: #fff;
  font-size: 20px;
  padding-left: 30px;
  margin-bottom: 20px;
}
.el-button--primary {
  background-color: #107a53;
  border: none;
}
.el-button--primary:hover {
  background-color: #fc6720;
}
.nav-btn {
  float: right;
  position: absolute;
  top: 50px;
  right: 450px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue